import type { Address } from "../Address.js";
import { type DeliveryDetails, deliveryInfoPerZoneMap } from "../deliveryInfoPerZoneMap.js";

// https://vdp.cuzk.gov.cz/vdp/ruian/spravniobvody?sort=&ohradaId=&nespravny=&nazevSp=&search=&page=1
const pragueAdministrativeDistrictCodeToZone: Record<string, keyof typeof deliveryInfoPerZoneMap> = {
	"19": 2, // Praha 1
	"27": 2, // Praha 2
	"35": 1, // Praha 3
	"43": 3, // Praha 4
	"51": 2, // Praha 5
	"60": 2, // Praha 6
	"78": 1, // Praha 7
	"86": 1, // Praha 8
	"94": 1, // Praha 9
	"108": 2, // Praha 10
	"116": 3, // Praha 11
	"124": 3, // Praha 12
	"132": 3, // Praha 13
	"141": 2, // Praha 14
	"159": 3, // Praha 15
	"205": 3, // Praha 16
	"213": 3, // Praha 17
	"221": 1, // Praha 18
	"167": 1, // Praha 19
	"175": 2, // Praha 20
	"183": 3, // Praha 21
	"191": 3, // Praha 22
};

// https://vdp.cuzk.gov.cz/vdp/ruian/obce
const cityCodeToZone: Record<string, keyof typeof deliveryInfoPerZoneMap> = {
	"538728": 3, // Říčany
};

/*
 * Některá katastrální území přesahují hranice více správních obvodů Prahy, takže je nelze
 * jednoznačně zařadit do zóny podle obvodu. Pro ně máme pevně danou zónu, která má přednost
 * před vyhodnocením podle obvodu Prahy níže.
 * https://vdp.cuzk.gov.cz/vdp/ruian/katastralniuzemi
 */
const cadastralUnitCodeToZone: Record<string, keyof typeof deliveryInfoPerZoneMap> = {
	"728161": 2, // Nusle
	"727164": 1, // Vinohrady
	"731943": 2, // Strašnice
	"731234": 1, // Hloubětín
};

export function getDeliveryDetails(address: Address): DeliveryDetails | "unreachable" | null {
	const { smartFormAddress } = address;
	if (!smartFormAddress) {
		return null;
	}
	/*
	 * CADASTRAL_UNIT_CODE obsahuje kód katastrálního území.
	 */
	if (smartFormAddress.CADASTRAL_UNIT_CODE) {
		const zone = cadastralUnitCodeToZone[smartFormAddress.CADASTRAL_UNIT_CODE];
		if (zone) {
			return deliveryInfoPerZoneMap[zone];
		}
	}
	/*
	 * CITY_AREA_3_CODE obsahuje kód správního obvodu Prahy.
	 */
	if (smartFormAddress.CITY_AREA_3_CODE) {
		const zone = pragueAdministrativeDistrictCodeToZone[smartFormAddress.CITY_AREA_3_CODE];
		if (zone) {
			return deliveryInfoPerZoneMap[zone];
		}
	}

	if (smartFormAddress.CITY_CODE) {
		const zone = cityCodeToZone[smartFormAddress.CITY_CODE];
		if (zone) {
			return deliveryInfoPerZoneMap[zone];
		}
	}

	return "unreachable";
}
